import { dynamicPagesHooksPanel as dynamicPagesHooksPanelDef } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'

export default async ({ hostname, editorSdkProxy, i18n }, { routerRef }) =>
  editorSdkProxy.editor.openModalPanel({
    url: await getPanelUrl({
      hostname,
      relativeUrl: dynamicPagesHooksPanelDef.url,
      editorSdkProxy,
    }),
    title: i18n.t('ADD_HOOKS_PANEL_TITLE'),
    width: 648,
    height: 414,
    initialData: {
      routerRef,
    },
    shouldHideHeader: true,
  })
